import { Component, OnInit , ViewChild } from '@angular/core';
import { DetailComponent } from './../detail/detail.component';
import { ConfService } from '../../conf.service';

@Component({
  selector: 'app-creator',
  templateUrl: './creator.component.html',
  styleUrls: ['./creator.component.scss']
})
export class CreatorComponent implements OnInit {

    partner: string;
    account: string;
  countNum: any;
  dmnAPI: any;
  executors: any;
  dmnExecutors: any;
  sqlQueryExecutors: any;
  thirdPartyAPI: any;
  thirdPartyApiExecutors: any;
  workFlowExecutors: any;
  dataAccessExecutors: any;

  countOfWorkflowApis = 0;
  countOfBusinessLogicApis = 0;
  countOfThirdPartyApis = 0;
  countOfSqlQueryApis = 0;
  countOfDmnApis = 0;
  countOfEmailTemplates = 0;
  countOfCampaigns = 0;
  countOfDataAccessExecutors = 0;

  daasLoaded = false;

  @ViewChild(DetailComponent) detail: DetailComponent;

  title = 'API Creators';
  cardType = 'creator';
  buttonType = 'creator';
  apiCreators = [
    {
        title: 'Data Access API',
        image: './assets/img/creator/da_create.jpg',
        caption: '',
        count: this.countOfDataAccessExecutors,
        documentRoute: '/documentation/',
        doctitle: 'Data%20Access%20API',
        version: 'v1',
        createRoute: '/dataaccessapi',
        // apiRoute: 'get-all-data-access-apis',
        apiRoute: '/devex/viewer/',
        id: 1
    },
    {
        title: 'Business Logic Builder',
        image: './assets/img/creator/bl_create.jpg',
        caption: '',
        count: this.countOfBusinessLogicApis,
        documentRoute: '/documentation/',
        doctitle: 'Business Logic API',
        version: 'v1',
        createRoute: '/businesslogic',
        // apiRoute: 'get-all-business-logic-apis',
        apiRoute: '/devex/viewer/',
        id: 2
    },
    // {
    //     title: 'Workflow Builder',
    //     image: './assets/img/creator/wf_create.png',
    //     caption: '',
    //     count: this.countOfWorkflowApis,
    //     documentRoute: '/documentation/',
    //     doctitle: '',
      //         version: 'v1',
    //     createRoute: '/workflow',
    //     // apiRoute: 'get-all-workflow-apis',
    //     apiRoute: '/devex/viewer/',
    //     id: 6
    // },
    // {
    //     title: 'Decision Builder',
    //     image: './assets/img/creator/decision_create.png',
    //     caption: '',
    //     count: this.countOfDmnApis,
    //     documentRoute: '/documentation/',
    //     doctitle: '',
      //         version: 'v1',
    //     createRoute: '/dmn',
    //     // apiRoute: 'get-all-decision-apis',
    //     apiRoute: '/devex/viewer/',
    //     id: 5
    // },
    {
        title: 'SQL Query Builder',
        image: './assets/img/creator/sql_create.jpg',
        caption: '',
        count: this.countOfSqlQueryApis,
        documentRoute: '/documentation/',
        doctitle: 'SQL%20Query%20API',
        version: 'v1',
        createRoute: '/querybuilder',
        // apiRoute: 'get-all-sql-query-apis',
        apiRoute: '/devex/viewer/',
        id: 3
    },
    // {
    //     title: 'Email Template Builder',
    //     image: './assets/img/creator/email_create.jpg',
    //     caption: '',
    //     count: this.countOfEmailTemplates,
    //     documentRoute: '/documentation/',
    //     doctitle: '',
    //     version: 'v1',
    //     createRoute: '/emailtemplatebuilder',
    //     // apiRoute: '/console',
    //     apiRoute: '/devex/viewer/',
    //     id: 1
    // },
    // {
    //     title: 'Campaign Manager',
    //     image: './assets/img/creator/campaign_create.jpg',
    //     caption: '',
    //     count: this.countOfCampaigns,
    //     documentRoute: '/documentation/',
    //     doctitle: '',
      //     version: 'v1',
      //     createRoute: '/emailtemplatebuilder',
    //     // apiRoute: '/console',
    //     apiRoute: '/devex/viewer/',
    //     id: 1
    // }
    ];

  constructor() { }

  async ngOnInit() {
    //   this.partner = localStorage.getItem('partner');
    //   this.account = localStorage.getItem('account');
    //
    //   await this.confPost.getApiExecutorsByPartnerAccountType(this.partner, this.account, 'API').toPromise().then(data => {
    //       this.dataAccessExecutors = data;
    //       localStorage.setItem('dataAccessAPI' , JSON.stringify(this.dataAccessExecutors));
    //       if (this.dataAccessExecutors) {
    //           this.countOfDataAccessExecutors = this.dataAccessExecutors.length;
    //       }
    //       this.daasLoaded = true;
    //   });
    //
    // await this.confPost.getApiExecutorsByPartnerAccountType(this.partner, this.account, 'THIRDPARTY').toPromise().then(data => {
    //             this.thirdPartyApiExecutors = data;
    //             localStorage.setItem('thirdPartyAPI' , JSON.stringify(this.thirdPartyApiExecutors));
    //             if (this.thirdPartyApiExecutors) {
    //                 this.countOfThirdPartyApis = this.thirdPartyApiExecutors.length;
    //             }
    //         });
    //
    // await this.confPost.getApiExecutorsByPartnerAccountType(this.partner, this.account, 'SQLQUERY').toPromise().then(data => {
    //             this.sqlQueryExecutors = data;
    //             localStorage.setItem('sqlQueryAPI' , JSON.stringify(this.sqlQueryExecutors));
    //             if (this.sqlQueryExecutors) {
    //                 this.countOfSqlQueryApis = this.sqlQueryExecutors.length;
    //                 this.apiCreators[1].count = this.countOfSqlQueryApis;
    //             }
    //         });
    // await this.confPost.getApiExecutorsByPartnerAccountType(this.partner, this.account, 'BUSINESSLOGIC').toPromise().then(data => {
    //                   localStorage.setItem('businessLogicAPI' , JSON.stringify(this.executors));
    //                   this.executors = data;
    //                   if (this.executors) {
    //                       this.countOfBusinessLogicApis = this.executors.length;
    //                   }
    //               });
    // await this.confPost.getApiExecutorsByPartnerAccountType(this.partner, this.account, 'WORKFLOW').toPromise().then(data => {
    //                   this.workFlowExecutors = data;
    //                   localStorage.setItem('workFlowAPI' , JSON.stringify(this.workFlowExecutors));
    //                   if (this.workFlowExecutors) {
    //                       this.countOfWorkflowApis = this.workFlowExecutors.length;
    //                   }
    //               });
    //   await this.confPost.getApiExecutorsByPartnerAccountType(this.partner, this.account, 'DECISION').toPromise().then(data => {
    //                     this.dmnExecutors = data;
    //                     localStorage.setItem('dmnAPI' , JSON.stringify(this.dmnExecutors));
    //                     if (this.dmnExecutors) {
    //                         this.countOfDmnApis = this.dmnExecutors.length;
    //                     }
    //                 });
  }
  }


